import { useCustomerStore } from '@/stores/customer'

export async function fetchLogout() {
  const router = useRouter()
  const route = useRoute()
  const locale = route.params.locale as string

  const customerStore = useCustomerStore()

  await $fetch('/customer/logout', {
    server: false,
    method: 'GET',
    credentials: 'include',
    query: {
      client: useRuntimeConfig().public.client,
    },
    baseURL: useRuntimeConfig().public.apiBaseURL,
    onResponse() {
      customerStore.$reset()
      router.push({ path: getPagePath['login']![locale] })
    },
  })
}
